<template>
  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button @click="this.$router.push('/quiz/activitee1')">
      <ion-icon class="puce-logo-white" :src="require('@/assets/icon-drapeau-quiz.svg')"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</template>

<script>
import QuizView from "@/views/QuizView.vue";
import {arrowForward, star} from "ionicons/icons";
import { IonFabButton } from '@ionic/vue'
import { IonFab, IonIcon } from "@ionic/vue";

export default {
  name: 'QuizStart',
  components: {
    IonFabButton,
    IonFab,
    IonIcon
  },
  methods: {
    star() {
      return star
    },
    arrowForward() {
      return arrowForward
    }
  },
  computed: {
    QuizView() {
      return QuizView
    }
  }
}
</script>

<style scoped>

ion-fab {
  margin-bottom: 4.5em;
}

ion-fab-button {
  border-radius: 50%;
  animation: bounce 3s infinite;
  animation-delay: 1s;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
  40% {transform: translateY(-15px);}
  60% {transform: translateY(-7px);}
}

@keyframes change-color {
  20% {background: #ffb224;}
  40% {background: #218ED9;}
  60% {background: #ee00ff;}
  90% {background: #e61f2b;}
}
</style>
